/**
 * Registers the single /service-worker.js for the app scope.
 * Production: Workbox SW from build/ (+ FCM snippet appended post-build).
 * Development: FCM-only SW from public/ when REACT_APP_FCM_ENABLED=true.
 */
import { isFcmClientEnabled } from "./config/firebase";

let registrationPromise = null;

function shouldRegisterServiceWorker() {
  if (!("serviceWorker" in navigator)) {
    return false;
  }
  if (process.env.NODE_ENV === "production") {
    return true;
  }
  return isFcmClientEnabled();
}

function registerInternal() {
  if (!shouldRegisterServiceWorker()) {
    return Promise.resolve(null);
  }

  const swUrl = `${process.env.PUBLIC_URL || ""}/service-worker.js`;

  return new Promise((resolve) => {
    window.addEventListener("load", () => {
      navigator.serviceWorker
        .register(swUrl)
        .then((registration) => {
          registration.onupdatefound = () => {
            const installing = registration.installing;
            if (!installing) {
              return;
            }
            installing.onstatechange = () => {
              if (
                installing.state === "installed" &&
                navigator.serviceWorker.controller
              ) {
                // New content available; app continues with existing controller until reload.
              }
            };
          };
          resolve(registration);
        })
        .catch((error) => {
          console.error("[service-worker] Registration failed:", error);
          resolve(null);
        });
    });
  });
}

export function getServiceWorkerRegistration() {
  if (!registrationPromise) {
    registrationPromise = registerInternal();
  }
  return registrationPromise;
}

export default function registerServiceWorker() {
  getServiceWorkerRegistration();
}
